import { HttpParams } from '@angular/common/http';
import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneUtils } from '../../../../../projects/kiene-core/src/lib/utils/KieneUtils';
import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import { SupplierMaterial } from '../supplier-material';

@Component({
    selector: 'kiene-supplier-material-selector',
    templateUrl: './supplier-material-selector.component.html',
    styleUrls: ['./supplier-material-selector.component.scss'],
})
export class SupplierMaterialSelectorComponent implements OnInit, OnChanges {
    @Input('materialId') materialId: number;
    @Input('supplierId') supplierId: number;

    @Output('change') change = new EventEmitter<SupplierMaterial>();

    supplierCtrl = new UntypedFormControl();

    currentSupplierMaterial = new SupplierMaterial();

    supplierMaterials: SupplierMaterial[] = [];

    constructor(
        private readonly api: KieneTableService,
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl: string,
    ) {}

    ngOnInit() {
        this.currentSupplierMaterial.artikel_id = this.materialId;
        this.currentSupplierMaterial.lieferant_id = this.supplierId;
        this.supplierCtrl.setValue(this.currentSupplierMaterial);

        this.loadSupplierMaterials();

        this.supplierCtrl.valueChanges.subscribe(supplierMaterial => {
            this.change.emit(supplierMaterial);
        });
    }

    ngOnChanges() {
        if (this.materialId) {
            this.currentSupplierMaterial.artikel_id = this.materialId;
            this.currentSupplierMaterial.lieferant_id = this.supplierId;
            this.loadSupplierMaterials();
        }
    }

    loadSupplierMaterials() {
        if (this.materialId) {
            let params = new HttpParams().set('artikel_id', this.materialId.toString());
            this.api.get(this.apiBaseUrl + 'artikel_lieferant/read.php', params).subscribe(
                response => {
                    this.supplierMaterials = response.records;
                    this.applySupplierSelection();
                },
                () => {},
            );
        }
    }

    private applySupplierSelection(): void {
        const lieferantId = this.supplierId ?? this.currentSupplierMaterial?.lieferant_id;
        if (lieferantId == null || !this.supplierMaterials?.length) {
            return;
        }
        const match = this.supplierMaterials.find(sm => KieneUtils.sameId(sm.lieferant_id, lieferantId));
        if (match) {
            this.supplierCtrl.setValue(match, { emitEvent: false });
        }
    }

    supplierMaterialComparator(smOne: SupplierMaterial, smTwo: SupplierMaterial) {
        if (!smOne || !smTwo) {
            return false;
        }
        return KieneUtils.sameId(smOne.lieferant_id, smTwo.lieferant_id);
    }
}
